import React from 'react'

/**
 * Custom hook to manage the document title.
 *
 * This hook sets the document title to the provided title when the component mounts.
 * It also ensures that the document title is reset to its default value when the component unmounts.
 *
 * @param {string} title - The title to set for the document.
 */
export default function useDocumentTitle(title: string) {
  // Save default title before changing it
  React.useEffect(() => {
    const defaultTitle = document.title

    return () => {
      document.title = defaultTitle
    }
  }, [])

  React.useEffect(() => {
    document.title = title
  }, [title])
}
